export const SET_PROCEDURE_FILTERS = 'SET_PROCEDURE_FILTERS';

export const RESET_PROCEDURE_FILTERS = 'RESET_PROCEDURE_FILTERS';

export const SET_PROCEDURE_GRID_SORT_CRITERIA = 'SET_PROCEDURE_GRID_SORT_CRITERIA';
